import { Theme } from 'config';

const styles = (theme: Theme) => ({
  label: {
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  modal: {
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  button: {
    border: 'none',
    backgroundColor: theme.violet,
    borderRadius: '1.5rem',
    color: '#fff !important',
    fontSize: '.8rem',
    opacity: 1,
    padding: '0.5rem 1.25rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
    cursor: 'pointer',
    textAlign: 'center',
    '&:focus': {
      outline: 0,
    },
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
    '.selected': {
      opacity: 0.7,
    },
    '&.fluid': {
      flex: 1,
    },
    '&:disabled': {
      backgroundColor: theme.disabledBtnGray,
      color: '#f7f8f9 !important',
      pointerEvents: 'none !important',
      opacity: 0.6,
    },
  },
  disabled: {
    backgroundColor: theme.disabledBtnGray,
    color: '#f7f8f9 !important',
    pointerEvents: 'none !important',
  },
  modalHeader: {
    fontSize: '1.25rem !important',
    fontFamily: 'DOSH !important',
    fontWeight: '400 !important',
    color: '#4a4a4a !important',
  },
  fieldGroup: {
    padding: '.5rem',
    overflow: 'visible',
    textOverflow: 'ellipsis',
  },
});

export default styles;
